module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"review_button_title":"Open detailed review popup"}}')
  delete Component.options._Ctor
}
